"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.array.find");
var _inquiry = require("@/api/inquiry.js");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _dictionary = require("@/config/dictionary");
var _index2 = require("@/utils/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'casePay',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      total: 0,
      loading: true,
      tableData: [],
      conditionData: '',
      //来自子组件的数据
      date: '',
      caseState: _dictionary.dictionary.caseState,
      multipleSelection: [],
      multipleSelectionId: [],
      caseBriefVisible: false,
      //案由弹窗
      reasonList: [],
      //案由数组
      form: {
        reasonId: ''
      },
      sumbiting: false,
      //批量审核中
      dealform: {},
      dealFormShow: false,
      arbitryData: [],
      payInfo: []
    };
  },
  activated: function activated() {
    this.currentPage = 1;
    this.init();
  },
  created: function created() {
    this.currentPage = 1;
    this.init();
  },
  components: {
    Caseconditons: _index.default
  },
  methods: {
    init: function init() {
      var _this = this;
      this.loading = true;
      (0, _inquiry.getPayLogList)({
        limit: this.pageLimit,
        page: this.currentPage,
        sort: "caseId",
        order: "asc"
      }).then(function (res) {
        if (res.code == 1) {
          _this.tableData = res.rows;
          _this.total = res.total;
          _this.loading = false;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: 'inquiryDetail',
        params: {
          caseId: val
        }
      });
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //表格审核事件
    handleReview: function handleReview(val) {
      var _this2 = this;
      (0, _inquiry.selectRegisterIsPayInfo)({
        caseId: val
      }).then(function (res) {
        if (res.code == 1) {
          if (res.data.amount && res.data.href) {
            // 从表格中找到对应的案件信息，补充缺失字段
            var caseRow = _this2.tableData.find(function (item) {
              return item.caseId === val;
            });
            if (caseRow) {
              _this2.dealform = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
                caseNo: res.data.caseNo || caseRow.caseNo,
                caseId: res.data.caseId || caseRow.caseId,
                appName: res.data.appName || caseRow.appName,
                resName: res.data.resName || caseRow.resName,
                arbitrationReason: res.data.arbitrationReason || caseRow.arbitrationReason
              });
            } else {
              _this2.dealform = res.data;
            }
            _this2.dealFormShow = true;
            console.log(_this2.dealform);
          } else {
            _this2.$message.warning("该案件未缴费！");
          }
        } else {
          _this2.$message.error(res.msg);
        }
      });
    },
    againSendPayNotice: function againSendPayNotice(val) {
      var _this3 = this;
      this.$confirm('确认再次发送缴费通知书?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _inquiry.sendRegisterPayBook)({
          caseId: val,
          type: 1
        }).then(function (res) {
          if (res.code == 1) {
            _this3.$message({
              message: '发送成功',
              type: 'success'
            });
          } else {
            _this3.$message.error(res.msg);
          }
        });
      });
    },
    //点击筛选，发送请求列表
    checkList: function checkList(data) {
      var _this4 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: data.caseId,
        caseNo: data.caseNo,
        partyName: data.partyName,
        defenceState: data.replyvalue,
        beginCtime: data.rowSecondDate[0],
        endCtime: data.rowSecondDate[1],
        caseType: data.caseTypevalue,
        beginRegisterTime: data.rowThirdDate[0],
        endRegisterTime: data.rowThirdDate[1],
        source: data.caseOriginvalue,
        limit: this.pageLimit,
        page: 1,
        sort: "caseId",
        order: "asc"
      };
      this.conditionData = postData;
      (0, _inquiry.getPayLogList)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this4.tableData = res.rows;
          _this4.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    cleanConditionData: function cleanConditionData() {
      this.conditionData = '';
      this.currentPage = 1;
      this.init();
    },
    //批量审核
    batchReview: function batchReview() {
      var _this5 = this;
      this.$confirm('确定批量审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _inquiry.getReasonList)().then(function (res) {
          _this5.reasonList = res.data;
          _this5.caseBriefVisible = true;
          if (_this5.$refs['form']) {
            _this5.$refs['form'].resetFields();
          }
        });
      });
    },
    // 案由弹窗确定按钮
    sumbitCaseBrief: function sumbitCaseBrief(formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.sumbiting = true;
          _this6.multipleSelection.forEach(function (item) {
            _this6.multipleSelectionId.push(item.caseId);
          });
          var reasonItem = _this6.reasonList.find(function (ele) {
            return ele.id == _this6.form.reasonId;
          });
          (0, _inquiry.batchFiling)({
            caseIds: _this6.multipleSelectionId,
            reasonId: _this6.form.reasonId,
            reasonName: reasonItem.reasonName
          }).then(function (res) {
            if (res.code == 1) {
              _this6.sumbiting = false;
              _this6.$message({
                message: '批量审核成功',
                type: 'success'
              });
              _this6.caseBriefVisible = false;
              _this6.init();
            } else {
              _this6.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      var _this7 = this;
      this.pageLimit = val;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.limit = val;
        this.conditionData.page = this.currentPage;
        this.conditionData.sort = "caseId";
        this.conditionData.order = "asc";
        (0, _inquiry.getPayLogList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getPayLogList)({
          limit: val,
          page: this.currentPage,
          sort: "caseId",
          order: "asc"
        }).then(function (res) {
          if (res.code == 1) {
            _this7.tableData = res.rows;
            _this7.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this8 = this;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        this.conditionData.sort = "caseId";
        this.conditionData.order = "asc";
        (0, _inquiry.getPayLogList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this8.tableData = res.rows;
            _this8.total = res.total;
            _this8.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getPayLogList)({
          limit: this.pageLimit,
          page: val,
          sort: "caseId",
          order: "asc"
        }).then(function (res) {
          if (res.code == 1) {
            _this8.tableData = res.rows;
            _this8.total = res.total;
            _this8.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;